var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPurpleBackground(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 576,
    height: 304,
    viewBox: "0 0 576 304",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "translate(-1)",
    fill: "url(#b)",
    d: "M0 0h577v312H0z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 288.5,
    y1: 0,
    x2: 288.5,
    y2: 312,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#705af8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423592"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M-1 0h577v312H-1z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPurpleBackground);
export default __webpack_public_path__ + "static/media/purple-background.762ffd2362fca8d76d5bec9e814d295c.svg";
export { ForwardRef as ReactComponent };